<template>
  <div class="container">
    <myNav></myNav>
    <div class="banner-sub">
      <el-carousel height="500px">
        <el-carousel-item v-for="item in bannerData" :key="item.key_word">
          <el-image :src="item.images.url"></el-image>
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="show-info">
      <div class="info-title">
        <p class="hot-bold">HOT RECOMMEND</p>
        <div><p class="hot-text">热门推荐</p></div>
      </div>
      <div class="hot-title">
        <el-row :gutter="24">
          <el-col :span="8" v-for="item in categroys" :key="item.id" @click.native="handler(item.id)">
            <div class="grid-content bg-purple info-active">{{ item.name }}</div>
          </el-col>
        </el-row>
      </div>
    </div>
    <div class="hot-con">
      <el-row>
        <el-col :span="6" v-for="item in hotClassify" :key="item.id" @click.native="openHotDetail(item)">
          <div class="grid-content bg-purple img-out">
            <el-image :src="item.main_img_url" class="pro-img"></el-image>
            <p class="info-show-title">{{ item.name }}</p>
          </div>
        </el-col>
      </el-row>
    </div>
    <!-- 供应商目录 -->
    <div class="supplier-out">
      <div class="supplier-con">
        <div class="info-title">
          <p class="hot-bold">BESTS SELLERS</p>
          <div><p class="hot-text">供应商目录</p></div>
        </div>
        <div class="sup-con">
          <div class="item-con" v-for="item in supData" :key="item.id" @click="openSupplier(item)">
            <div class="sup-item">
              <div class="sup-img"><img :src="item.main_img_url" alt="" /></div>
              <div class="sup-info">
                <div class="sup-title">{{ item.name }}</div>
                <div class="sup-text">{{ item.memo }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 粮油米面 -->
    <div v-for="category in categroys" class="bur-out">
      <div class="info-title">
        <p class="hot-bold">PRODUCT CENTER</p>
        <el-row>
          <el-col :span="22">
            <p class="hot-text">{{ category.name }}</p>
          </el-col>
          <el-col :span="2"><el-button type="success" class="all-btn" @click="openDetail(category)">查看更多>></el-button></el-col>
        </el-row>
      </div>
      <div class="bur-con">
        <div class="item-con-s" v-for="item in category.productData" :key="item.id" @click="openDetails(item)">
          <div class="sup-item-s">
            <div class="sup-img"><img :src="item.main_img_url" alt="" /></div>
            <div class="sup-info">
              <div class="sup-title">{{ item.name }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 备案号 -->
    <div class="icp-out">
      <div class="icp-con">
        <p>
          <a style="color:#fff;" href="https://beian.miit.gov.cn/" target="_blank">
            <span v-if="url.includes('zjcqq.com')">浙ICP备19020366号-3</span>
            <span v-if="url.includes('shian360.com')">浙ICP备19020366号-1</span>
            <span v-else>浙ICP备19020366号-6</span>
          </a>
          Copyright 2020-2028 版权所有 © 菜圈圈
        </p>
        <p>地址：浙江丽水市莲都区丽水数字经济双创园3号楼7楼701室 联系电话：152 0588 0610 公司邮箱：1091556104@qq.com</p>
      </div>
    </div>
  </div>
</template>

<script>
import myNav from './nav/myNav'
import { proModuleApi } from '@/api/home'
export default {
  name: 'index',
  components: {
    myNav
  },
  data() {
    return {
      banner: [],
      categroys: [],
      hotClassify: [],
      currentId: 2,
      supData: [],
      burData: [],
      farmData: [],
      meatData: [],
      bannerData: [],
      url: ''
    }
  },
  created() {
    this.url = window.location.hostname
    this.getBanner()
    this.getCategoryAll()
    this.getClassify()
    this.getSupplier()
  },
  methods: {
    getBanner() {
      proModuleApi
        .getbanner(1)
        .then(res => {
          this.bannerData = res.data.items
        })
        .catch()
    },
    getCategoryAll() {
      proModuleApi
        .getCategory()
        .then(res => {
          if (res.status) {
            this.categroys = res.data
            this.getProduct()
          }
        })
        .catch(err => {})
    },
    getClassify() {
      proModuleApi
        .getHotClassify()
        .then(res => {
          let data = []
          data = res.data.filter(item => item.id == this.currentId)
          this.hotClassify = data[0].product
        })
        .catch(err => {})
    },
    getSupplier() {
      proModuleApi
        .getSupplier()
        .then(res => {
          this.supData = res.data.slice(0, 6)
        })
        .catch()
    },
    getProduct() {
      this.categroys.map((item, index) => {
        proModuleApi.productClassify(item.id).then(res => {
          if (res.status) {
            this.$set(this.categroys[index], 'productData', res.data)
          }
        })
      })
    },
    handler(e) {
      this.currentId = e
      this.getClassify()
    },
    openHotDetail(item) {
      this.$router.push({
        path: '/infor',
        query: {
          id: item.id
        }
      })
    },
    openDetail(item) {
      this.$router.push({
        path: '/detail',
        query: {
          id: item.id,
          name: item.name
        }
      })
    },
    openDetails(item) {
      this.$router.push({
        path: '/infor',
        query: {
          id: item.id
        }
      })
    },
    openSupplier(item) {
      console.log(item)
      this.$router.push({
        path: '/supplier',
        query: {
          id: item.id
        }
      })
    }
  }
}
</script>
<style scoped>
.nav-img {
  padding: 20px;
  width: 1200px;
  margin: 0 auto;
}
.issue-btn {
  float: right;
  margin-top: 15px;
}
.nav-info {
  background-color: #107a53;
}
.el-menu {
  width: 1200px;
  background-color: #107a53;
  border-right: none;
  margin: 0 auto;
}
.el-menu-item {
  display: inline-block;
  color: #fff;
  margin: 0;
  list-style: none;
  padding: 0 100px;
}
.banner-sub {
  min-height: 400px;
  width: 100%;
  overflow: hidden;
}
.show-info {
  width: 1200px;
  margin: 80px auto 0;
  overflow: hidden;
}
.info-title {
  width: 600px;
  border-bottom: 2px solid #d3d3d3;
  padding-bottom: 5px;
  float: left;
}
.info-title p {
  font-size: 24px;
  font-weight: 700;
}
.hot-bold {
  margin-bottom: 0;
}
.hot-text {
  margin: 0;
  width: 800px;
  color: #107a53;
}
.hot-title {
  width: 600px;
  margin-top: 40px;
  float: left;
}
.hot-con {
  width: 1200px;
  margin: 30px auto;
  padding: 10px;
}
.info-show-title {
  text-align: center;
  margin: 0;
}
.info-active.active {
  background-color: #107a53;
}
.info-active {
  background: #363e45;
  color: #fff;
  text-align: center;
  height: 50px;
  line-height: 50px;
}
.img-out {
  width: 90%;
  box-shadow: 0 0 8px #c7c9c6;
  margin: 0 auto;
  padding-bottom: 10px;
  height: 300px;
}
.supplier-out {
  background-color: #107a53;
  padding-bottom: 20px;
}
.supplier-con {
  width: 1200px;
  margin: 0 auto;
  color: #fff;
  overflow: hidden;
}
.supplier-con .info-title {
  width: 100%;
}
.supplier-con .hot-text {
  color: #fff;
}
.sup-con {
  width: 100%;
  overflow: hidden;
  padding-top: 20px;
}
.item-con {
  width: 400px;
  height: 200px;
  float: left;
}
.sup-item {
  width: 380px;
  float: left;
  height: 180px;
  background-color: #363e45;
  margin-top: 10px;
  margin-left: 10px;
}
.sup-img,
.sup-info {
  float: left;
  width: 200px;
}
.sup-img {
  width: 150px;
}
.sup-img img {
  width: 150px;
}
.sup-info {
  padding: 10px 10px 10px 20px;
}
.sup-title {
  font-size: 18px;
  color: #fff;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}
.sup-text {
  font-size: 14px;
  height: 135px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 7;
  -webkit-box-orient: vertical;
}
.bur-out,
.farm-con {
  width: 1200px;
  margin: 0 auto;
  overflow: hidden;
}
.bur-out .info-title {
  width: 1000px;
}
.hot-con,
.bur-con {
  width: 1200px;
  overflow: hidden;
}
/* 备案 */
.icp-out {
  background-color: #107a53;
  padding: 20px 0;
}
.icp-con {
  width: 1200px;
  margin: 0 auto;
  color: #fff;
  text-align: center;
}
.bur-con {
  margin-top: 20px;
}

.bur-con .sup-item {
  background-color: #107a53;
}
.item-con-s {
  width: 280px;
  margin: 10px;
  overflow: hidden;
  float: left;
  background-color: #107a53;
  height: 200px;
}
.sup-item-s {
  width: 280px;
  overflow: hidden;
  text-align: center;
  padding-top: 8px;
}
.item-con-s .sup-img {
  width: 280px;
  margin: 0 auto;
  text-align: center;
  height: 150px;
}

.sup-item-s .sup-info {
  width: 100%;
}
.sup-img img {
  height: 150px;
}

.item-con-s .sup-info {
  padding-left: 10px;
}
.farm-out .item-con-s {
  background-color: #fff;
}
.flot-button {
  float: right;
}
.bur-out,
.farm-con {
  position: relative;
}
.flot-button {
  position: absolute;
  right: 20px;
  top: 30px;
}
.pro-img {
  height: 270px;
}
</style>



// WEBPACK FOOTER //
// src/components/index.vue